export const CUSTOM_THEME_COLOR_NAMES = {
  BASE: 'BASE'
};
export const CUSTOM_THEME_IMAGE_NAMES = {
  LOGO: 'LOGO'
};
export const PARTICIPATION_ACTION_TYPES = {
  EXCLUDE: 'EXCLUDE',
  INCLUDE: 'INCLUDE'
};

export const SURVEY_REDIRECTION_URL_PROPERTY_TYPES = {
  TRANSFER_INPUT_PATH_URL_PARAM: 'TRANSFER_INPUT_PATH_URL_PARAM',
  TRANSFER_INPUT_QUERY_URL_PARAM: 'TRANSFER_INPUT_QUERY_URL_PARAM',
  USER_PROPERTY_OUTPUT: 'USER_PROPERTY_OUTPUT'
};

export const SURVEY_REDIRECTION_INPUT_USER_PROPERTIES = {
  EMAIL: 'EMAIL',
  USER_ID: 'USER_ID',
  ENCRYPTED_USER_ID: 'ENCRYPTED_USER_ID',
  RESULT_ID: 'RESULT_ID',
  GENDER: 'GENDER',
  AGE: 'AGE'
};

export const TRANSFER_INPUT_PATH_URL_PARAM_TYPES = {
  CUSTOM_CLIENT_IDENTIFIER: 'CUSTOM_CLIENT_IDENTIFIER',
  CUSTOM_CLIENT_NAME: 'CUSTOM_CLIENT_NAME'
};

export const surveyRedirectionLinkTypes = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  QUOTA_FULL: 'QUOTA_FULL'
};
